import React from "react";
import BackToStandardList from "../BackToStandardList";
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import StepIcon from '@material-ui/core/StepIcon';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as fuiRedux from "../../../redux/fui/index";

import Typography from '@material-ui/core/Typography';
import {
  Avatar,
  Tooltip,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core";
import {
  PageWrapper,
  LeftColumn,
  RightColumn,
  DetailsTypography,
  StyledExpansionPanel,
  FirstLineWrapper,
  StyledTypography,
  StyledParagraphBold,
  TextWrapper,
  LongDivider,
  StyledTypographyHeader,
} from "../FuiStyles";
import ConfigurationType from "../ConfigurationType";
// import { ProductsInfomation } from "../Constants/ProductsInfomation";
import {
  ProductsInformationPam,
  ProductsInformationMcc,
} from "../Constants/ProductsInformationOtherIntiatives";
import BookIcon from "@material-ui/icons/Book";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useEffect, useState } from "react";
import axios from "axios";
import base from '../../../config';

/**
 * Automatic Ticket Resolver form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: AppStepper
 */


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: "0px"
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

// Custom Step Icon Component that always shows numbers (1, 2, 3)
function CustomStepIcon(props) {
  const { icon } = props;

  return (
    <div
      style={{
        backgroundColor: '#7500C0',
        zIndex: 1,
        color: '#fff',
        width: 24,
        height: 24,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
      }}
    >
      {icon}
    </div>
  );
}

//Choose a configuration type and enter into quick or full configuration components
const GeneralForm = ({
  setActiveStep,
  activeStep,
  FormId,
  LeftColumnFields,
  ClientContractFields,
  EnvironmentFields,
  ApplicationFields,
  RightColumnFields,
  ProvisionDetails,
  history,
  NoConfig,
  belong,
  productname,
  customurl,
  validateInputFields
}) => {
  function getSteps() {
    return ['Client & Contract Information', 'Environment Details', 'Application Configuration Details'];
  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return ClientContractFields
      case 1:
        return EnvironmentFields
      case 2:
        return ApplicationFields
      default:
        return 'Unknown step';
    }
  }
  const classes = useStyles();
  const steps = getSteps();
  const [ProductsInfomation, setProductInformation] = useState([]);
  // Resolve the active catalog based on which initiative this product belongs to
  const selectedCatalog = belong === "MCC"
    ? ProductsInformationMcc
    : belong === "pam"
      ? ProductsInformationPam
      : ProductsInfomation;

  // Look up the product by its `id` field instead of raw array index.
  // Array position (products[FormId]) breaks the moment entries in the
  // Constants file are reordered, removed, or commented out — id-based
  // lookup is stable regardless of array position.
  const catalogProducts = (selectedCatalog && selectedCatalog.products) ? selectedCatalog.products : [];
  const staticProduct = catalogProducts.find(
    function (p) { return String(p.id) === String(FormId); }
  );

  // Fallback: if the static constants file has no match for this FormId,
  // pull product info from the live API instead of crashing.
  const [apiProduct, setApiProduct] = useState(null);

  useEffect(() => {
    if (staticProduct) return; // static lookup already succeeded, no need to call API

    let isMounted = true;
    const idToken = localStorage.getItem("token");

    axios.get(`${base.app.apiSite}fui/appversion`, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }).then((resp) => {
      if (!isMounted) return;
      const match = Array.isArray(resp.data)
        ? resp.data.find((p) => String(p.id) === String(FormId))
        : null;
      setApiProduct(match || null);
      if (!match) {
        console.error("GeneralForm: no product found for FormId in API either:", FormId);
      }
    }).catch((err) => {
      console.error("GeneralForm: API fallback fetch failed:", err);
    });

    return () => { isMounted = false; };
  }, [FormId, staticProduct]);

  const currentProduct = staticProduct || apiProduct;

  if (!currentProduct) {
    // console.error("GeneralForm: no product found for FormId:", FormId, "in catalog belong:", belong || "default");
  }

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      // Final step - perform full form validation before submit
      if (validateInputFields) {
        const isValid = validateInputFields('submit');
        if (isValid) {
          // Validation passed, proceed with form submission
          return;
        }
        // Validation failed, validation dialog should already be showing
        // Don't proceed further
        return;
      }
    }

    // For non-final steps, just move to next step without validation
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    // setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  useEffect(() => {
    if (productname === 'AgentMesh' || productname === 'CIA' || productname === 'DedicatedVirtualNetworkSetup' || productname === 'BedrockPlatform') {
      setActiveStep(2);
    }
  }, [])

  return (
    <div>
      {/* <PageWrapper> */}
      <BackToStandardList history={history} productname={productname} />
      <StyledTypographyHeader variant="h1">
        {currentProduct ? currentProduct.productName : ""}
      </StyledTypographyHeader>

      <DetailsTypography>
        {currentProduct ? currentProduct.productDescription : ""}
      </DetailsTypography>
      {!NoConfig && <ConfigurationType productname={productname} />}

      <LongDivider />
      <LeftColumn>{LeftColumnFields}</LeftColumn>
      <RightColumn>
        {/* <TextWrapper>
            <StyledParagraphBold>
              PRODUCT CONFIGURATION DETAILS:
            </StyledParagraphBold>
          </TextWrapper> */}

        {RightColumnFields}
      </RightColumn>

      {/* </PageWrapper> */}
      {(productname !== 'AgentMesh' && productname !== 'CIA' && productname !== 'DedicatedVirtualNetworkSetup' && productname !== 'BedrockPlatform') ?
        <>
          <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical" style={{ padding: "0px" }}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={CustomStepIcon}><p style={{ fontSize: "17px" }}>{label}</p></StepLabel>
                  <StepContent>
                    <Typography>{getStepContent(index)}</Typography>
                    <div className={classes.actionsContainer}>
                      <div>
                        <Button

                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                        {activeStep === steps.length - 1 ? "" :
                          <Button
                            style={{ float: "right" }}
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            className={classes.button}
                          >
                            Next
                          </Button>}
                           
                        {(activeStep === 2 && validateInputFields !== undefined) &&
                          <Button
                            style={{ float: "right" }}
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            disabled={productname == 'NoTouch' ? true : false}
                            className={classes.button}
                          >
                            Submit
                          </Button>}
                      </div>
                    </div>
                  </StepContent>
                </Step>
              ))}
            </Stepper>

            {/* {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
        </Paper>
      )} */}
          </div>
        </> : (productname === 'DedicatedVirtualNetworkSetup' || productname === 'BedrockPlatform') ?
          <>
            <div style={{ width: '100%', height: '50px', fontSize: '1.1em', border: 'none' }}>
              <h4 style={{ fontWeight: '500', color: '#555555' }}>Please fill out the required information to proceed further</h4>
            </div>
            <Typography style={{ height: 'auto', margin: '10px 0 20px 0', paddingBottom: '20px' }}>
              {ProvisionDetails}
              <Button
                style={{ float: "right", top: '10px' }}
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
              >
                Submit
              </Button>
            </Typography>
          </>
          :
          <>
            <div style={{ width: '100%', height: '50px', fontSize: '1.5em', border: 'none' }}>
              Provisioning Details
            </div>
            <div style={{ width: '100%', height: '40px', fontSize: '.9em', border: 'none' }}>
              <span style={{ color: " #0041F0" }}>Application Custom URL: {customurl}</span>
            </div>
            <Typography style={{ height: 'calc(45vh - 50px)' }}>{ProvisionDetails}</Typography>
            <Button
              style={{ float: "right", top: '-30px' }}
              variant="contained"
              color="primary"
              onClick={handleNext}
              className={classes.button}
            >
              Submit
            </Button>
          </>
      }
    </div>
  );
};

const MSTP = (state) => ({
  activeStep: state.fui.activeStep
});

GeneralForm.propTypes = {
  setActiveStep: PropTypes.func,
};

export default connect(MSTP, {
  setActiveStep: fuiRedux.setActiveStep,
})(GeneralForm);

